import React from 'react';
import { Helmet } from 'react-helmet-async';
import { buildAbsoluteUrl, rebaseUrl } from '../../config/domain';

// Facebook App ID for STAGSTER (set REACT_APP_FB_APP_ID in .env.production).
// Empty = no fb:app_id tag, which is correct until a real app is registered.
const FB_APP_ID = process.env.REACT_APP_FB_APP_ID || '';

// Lightweight meta helper to set per-route SEO tags without changing UI
export default function Meta({
  title,
  description,
  canonical,
  noindex = false,
  og = {},
  twitter = {},
  jsonLd = []
}) {
  const robots = noindex ? 'noindex, nofollow' : 'index, follow';
  const ldArray = Array.isArray(jsonLd) ? jsonLd : [jsonLd].filter(Boolean);

  const ogTitle = og.title || title;
  const ogDescription = og.description || description;
  const twTitle = twitter.title || ogTitle;
  const twDescription = twitter.description || ogDescription;

  const canonicalUrl = canonical ? buildAbsoluteUrl(canonical) : undefined;

  const resolvedOg = {
    ...og,
  };

  // Set default og:url if not provided
  if (!resolvedOg.url) {
    resolvedOg.url = buildAbsoluteUrl(canonical || '/');
  } else {
    resolvedOg.url = buildAbsoluteUrl(resolvedOg.url);
  }
  
  if (resolvedOg.image) {
    resolvedOg.image = rebaseUrl(resolvedOg.image);
  }

  const resolvedTwitter = {
    ...twitter,
  };

  if (resolvedTwitter.image) {
    resolvedTwitter.image = rebaseUrl(resolvedTwitter.image);
  }

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={robots} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {resolvedOg.type && <meta property="og:type" content={resolvedOg.type} />}
      {resolvedOg.url && <meta property="og:url" content={resolvedOg.url} />}
      {resolvedOg.image && <meta property="og:image" content={resolvedOg.image} />}
      {resolvedOg.imageAlt && <meta property="og:image:alt" content={resolvedOg.imageAlt} />}
      {FB_APP_ID && <meta property="fb:app_id" content={FB_APP_ID} />}

      {resolvedTwitter.card && <meta name="twitter:card" content={resolvedTwitter.card} />}
      {twTitle && <meta name="twitter:title" content={twTitle} />}
      {twDescription && <meta name="twitter:description" content={twDescription} />}
      {resolvedTwitter.image && <meta name="twitter:image" content={resolvedTwitter.image} />}

      {ldArray.map((obj, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
